import { ApeironSsoCookieKey as o, ApeironSsoLoginType as w } from "../constants/apeironSso.js";
import { LocalStorageKey as g } from "../../temp-lib/constants/storage.js";
import { sameTokenSession as c, readToken as m } from "../../temp-lib/util/authenication/token.js";
import p from "universal-cookie";
const f = () => ({
  path: "/",
  domain: typeof window < "u" && window.location.hostname.endsWith(".apeironnft.com") ? ".apeironnft.com" : void 0,
  sameSite: "lax",
  secure: typeof window < "u" && window.location.protocol === "https:"
}), T = () => new p().get(o.Logout, { doNotParse: !0 }), S = (n, s) => {
  var d;
  if (typeof window > "u") return;
  const e = new p(), t = e.get(o.AccessToken, {
    doNotParse: !0
  });
  if (t && !c(t, s) && !c(t, n))
    return;
  const i = f();
  e.set(o.AccessToken, n, i);
  const r = localStorage.getItem(g.SsoLoginType);
  r && Object.values(w).includes(
    r
  ) && e.set(o.LoginType, r, i);
  const a = (d = m(n)) == null ? void 0 : d.loginNetwork;
  a && e.set(o.ChainType, a, i);
}, h = (n) => {
  if (typeof window > "u") return;
  const s = new p(), e = s.get(o.AccessToken, {
    doNotParse: !0
  });
  if (!c(n, e)) return;
  const t = f();
  for (const i of [
    o.AccessToken,
    o.LoginType,
    o.ChainType,
    o.WalletType
  ])
    s.remove(i, t);
};
export {
  h as clearSessionCookie,
  f as sessionCookieOptions,
  T as sharedLogout,
  S as syncSessionCookie
};
//# sourceMappingURL=sessionCookies.js.map
